import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import VueI18n from "vue-i18n";
// Localisation language file
import { messages } from "@/common/config/i18n/vuetify-language";
import i18nService from "@/common/i18n.service.js";

Vue.use(Vuetify);
Vue.use(VueI18n);

// get current selected language
const lang = i18nService.getActiveLanguage();

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: lang, // set locale
  messages, // set locale messages
});

i18nService.onLanguageChanged((language) => {
  i18n.locale = language;
});

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: "#5867dd",
        secondary: "#e8ecfa",
        accent: "#5d78ff",
        error: "#fd397a",
        info: "#5578eb",
        success: "#0abb87",
        warning: "#ffb822",
      },
    },
  },
  lang: {
    t: (key, ...params) => i18n.t(key, params),
  },
});
